import Api from './Api';
import Configuracao from '../util/Configuracao';

class GlosaApi extends Api {
  async consultarMotivosDeGlosa () {
    try {
      const urlConsultarMotivosDeGlosa = Configuracao.getConfiguracao().urlConsultarMotivosDeGlosa;
      const response = await this.fetch(urlConsultarMotivosDeGlosa);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default GlosaApi;
